import * as yup from 'yup';

const _checkValid = (value) => {
  return value !== undefined && value !== null && value !== '';
};

const _createValidationSchema = (fields) => {
  return yup.lazy(() => {
    return yup.number().when(fields, {
      is: (...values) => values.some((value) => _checkValid(value)),
      then: () => yup.number().required(),
      otherwise: () => yup.number().notRequired(),
    });
  });
};

const validationSchema = yup.object({
  b2c: yup.object({
    deposit: yup.object().shape({
      averagePaymentDays: _createValidationSchema([
        'age',
        'turnover',
        'vehicles',
        'unpaidAmount',
        'unpaidAgingDays',
      ]),
      age: _createValidationSchema([
        'averagePaymentDays',
        'turnover',
        'vehicles',
        'unpaidAmount',
        'unpaidAgingDays',
      ]),
      turnover: _createValidationSchema([
        'averagePaymentDays',
        'age',
        'vehicles',
        'unpaidAmount',
        'unpaidAgingDays',
      ]),
      vehicles: _createValidationSchema([
        'averagePaymentDays',
        'age',
        'turnover',
        'unpaidAmount',
        'unpaidAgingDays',
      ]),
      unpaidAmount: _createValidationSchema([
        'averagePaymentDays',
        'age',
        'turnover',
        'vehicles',
        'unpaidAgingDays',
      ]),
      unpaidAgingDays: _createValidationSchema([
        'averagePaymentDays',
        'age',
        'turnover',
        'vehicles',
        'unpaidAmount',
      ]),
    }),
    standingOrder: yup.object().shape({
      averagePaymentDays: _createValidationSchema([
        'age',
        'turnover',
        'vehicles',
        'unpaidAmount',
        'unpaidAgingDays',
      ]),
      age: _createValidationSchema([
        'averagePaymentDays',
        'turnover',
        'vehicles',
        'unpaidAmount',
        'unpaidAgingDays',
      ]),
      turnover: _createValidationSchema([
        'averagePaymentDays',
        'age',
        'vehicles',
        'unpaidAmount',
        'unpaidAgingDays',
      ]),
      vehicles: _createValidationSchema([
        'averagePaymentDays',
        'age',
        'turnover',
        'unpaidAmount',
        'unpaidAgingDays',
      ]),
      unpaidAmount: _createValidationSchema([
        'averagePaymentDays',
        'age',
        'turnover',
        'vehicles',
        'unpaidAgingDays',
      ]),
      unpaidAgingDays: _createValidationSchema([
        'averagePaymentDays',
        'age',
        'turnover',
        'vehicles',
        'unpaidAmount',
      ]),
      successRateStandingOrders: _createValidationSchema([
        'averagePaymentDays',
        'age',
        'turnover',
        'vehicles',
        'unpaidAmount',
        'unpaidAgingDays',
      ]),
    }),
  }),
  b2b: yup.object({
    deposit: yup.object().shape({
      averagePaymentDays: _createValidationSchema([
        'age',
        'turnover',
        'vehicles',
        'unpaidAmount',
        'unpaidAgingDays',
      ]),
      age: _createValidationSchema([
        'averagePaymentDays',
        'turnover',
        'vehicles',
        'unpaidAmount',
        'unpaidAgingDays',
      ]),
      turnover: _createValidationSchema([
        'averagePaymentDays',
        'age',
        'vehicles',
        'unpaidAmount',
        'unpaidAgingDays',
      ]),
      vehicles: _createValidationSchema([
        'averagePaymentDays',
        'age',
        'turnover',
        'unpaidAmount',
        'unpaidAgingDays',
      ]),
      unpaidAmount: _createValidationSchema([
        'averagePaymentDays',
        'age',
        'turnover',
        'vehicles',
        'unpaidAgingDays',
      ]),
      unpaidAgingDays: _createValidationSchema([
        'averagePaymentDays',
        'age',
        'turnover',
        'vehicles',
        'unpaidAmount',
      ]),
    }),
    standingOrder: yup.object().shape({
      averagePaymentDays: _createValidationSchema([
        'age',
        'turnover',
        'vehicles',
        'unpaidAmount',
        'unpaidAgingDays',
      ]),
      age: _createValidationSchema([
        'averagePaymentDays',
        'turnover',
        'vehicles',
        'unpaidAmount',
        'unpaidAgingDays',
      ]),
      turnover: _createValidationSchema([
        'averagePaymentDays',
        'age',
        'vehicles',
        'unpaidAmount',
        'unpaidAgingDays',
      ]),
      vehicles: _createValidationSchema([
        'averagePaymentDays',
        'age',
        'turnover',
        'unpaidAmount',
        'unpaidAgingDays',
      ]),
      unpaidAmount: _createValidationSchema([
        'averagePaymentDays',
        'age',
        'turnover',
        'vehicles',
        'unpaidAgingDays',
      ]),
      unpaidAgingDays: _createValidationSchema([
        'averagePaymentDays',
        'age',
        'turnover',
        'vehicles',
        'unpaidAmount',
      ]),
      successRateStandingOrders: _createValidationSchema([
        'averagePaymentDays',
        'age',
        'turnover',
        'vehicles',
        'unpaidAmount',
        'unpaidAgingDays',
      ]),
    }),
  }),
});

export default validationSchema;
